import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '爱爱网',
  url: 'https://aiaiwang.com',
  description: '爱爱网是专注成人情感与亲密关系的交流平台，提供情感咨询、两性健康知识、伴侣沟通技巧等优质内容。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://aiaiwang.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <SEOHead
        title="爱爱网 - 成人情感交流平台官方入口"
        description="爱爱网是专注成人情感与亲密关系的交流平台，提供情感咨询、两性健康知识、伴侣沟通技巧等优质内容。加入爱爱网，探索健康、开放、负责任的亲密关系，获取专业两性指导与社区支持。"
        keywords="爱爱网,爱爱网官网入口,爱爱网成人交流,两性情感咨询,亲密关系指导,成人健康知识,伴侣沟通技巧"
      />
      <Navbar />
      <main className="pt-16">
        <Hero />
        <CategoryGrid />
        <FeaturedArticles />
        <CTASection />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}